import { type FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Stack } from '@dhl-ui/components'
import { Language } from '@dhl/i18n'

import { links } from '~/appLinks'
import { isFeatureEnabled } from '~/config'
import { locales, useLocalStorageForLocale } from '~/i18n'

export const HeaderContent: FC = () => {
  const { t } = useTranslation()
  const [, storeLocale] = useLocalStorageForLocale()

  const handleSignInClick = () => {
    window.location.href = links.signInLink()
  }

  return (
    <Stack direction="row" spacing={1}>
      <Language locales={locales()} size="small" onSelectLanguage={storeLocale} />

      {isFeatureEnabled('profile') && (
        <Button data-test="btn-goto-login" onClick={handleSignInClick} size="small" variant="contained">
          {t('onboarding.loginButton')}
        </Button>
      )}
    </Stack>
  )
}
